'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var boolToStr = Boolean.prototype.toString;

var tryBooleanObject = function tryBooleanObject(value) {
  try {
    boolToStr.call(value);
    return true;
  } catch (e) {
    return false;
  }
};

var toStr = Object.prototype.toString;
var boolClass = '[object Boolean]';
var hasToStringTag = typeof Symbol === 'function' && (0, _typeof2["default"])(Symbol.toStringTag) === 'symbol';

module.exports = function isBoolean(value) {
  if (typeof value === 'boolean') {
    return true;
  }

  if ((0, _typeof2["default"])(value) !== 'object') {
    return false;
  }

  return hasToStringTag ? tryBooleanObject(value) : toStr.call(value) === boolClass;
};